

import React from 'react';
import { Button, Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ApiError = ({ retryFetch, errorMessage }) => {
  const { t } = useTranslation();

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center vh-100">
      <Row className="w-100">
        <Col md={{ size: 6, offset: 3 }} className="text-center bg-light p-4 rounded shadow white-content ">
          <h2>{t("error.apiError.title")}</h2>
          <p>{errorMessage || t("error.apiError.message")}</p>
          {retryFetch && (
            <Button color="primary" onClick={() => retryFetch()} className="mt-3">
              {t("error.action.retry", "Retry")}
            </Button>
          )}
          <div className="mt-4">
            <Link to="/" className="btn btn-link">
              {t("link.label.home")}
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
};



    


export default ApiError;